/**************************************************
 * Nombre:       CatalogoLista
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import ListaOfertas from "./ListaOfertas";

const CatalogoLista = () => {


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 0}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8, px: 6}}>
                    <ListaOfertas items={data}/>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default CatalogoLista

const data = [
    {
        nombre: 'ESCUELA DE ESTETICA Y BIENESTAR HUMANO',
        items: [
            'Técnico laboral por competencias en cosmetología y estética integral',
            'Técnico laboral por competencias en estilista integral',
            'Técnico laboral por competencias en barbería'
        ]
    },
    {
        nombre: 'ESCUELA DE ESTETICA Y BIENESTAR HUMANO',
        items: [
            'Técnico laboral por competencias en cosmetología y estética integral',
            'Técnico laboral por competencias en estilista integral',
            'Técnico laboral por competencias en barbería'
        ]
    },
    {
        nombre: 'ESCUELA DE ESTETICA Y BIENESTAR HUMANO',
        items: [
            'Técnico laboral por competencias en cosmetología y estética integral',
            'Técnico laboral por competencias en estilista integral',
            'Técnico laboral por competencias en barbería'
        ]
    },
    {
        nombre: 'ESCUELA DE ESTETICA Y BIENESTAR HUMANO',
        items: [
            'Técnico laboral por competencias en cosmetología y estética integral',
            'Técnico laboral por competencias en estilista integral',
            'Técnico laboral por competencias en barbería'
        ]
    },
    {
        nombre: 'ESCUELA DE ESTETICA Y BIENESTAR HUMANO',
        items: [
            'Técnico laboral por competencias en cosmetología y estética integral',
            'Técnico laboral por competencias en estilista integral',
            'Técnico laboral por competencias en barbería'
        ]
    },
    {
        nombre: 'ESCUELA DE ESTETICA Y BIENESTAR HUMANO',
        items: [
            'Técnico laboral por competencias en cosmetología y estética integral',
            'Técnico laboral por competencias en estilista integral',
            'Técnico laboral por competencias en barbería'
        ]
    },
]